import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'relativeTime', pure: true })
export class RelativeTimePipe implements PipeTransform {
	transform(date?: any, locale = 'nb-NO') {
		if (!date) return undefined;
		const rtf = new Intl.RelativeTimeFormat(locale);
		const now = new Date();
		const past = new Date(date);
		const seconds = (past.getTime() - now.getTime()) / 1000;
		if (Math.abs(seconds) < 60)
			return rtf.format(Math.round(seconds), 'second');
		const minutes = seconds / 60;
		if (Math.abs(minutes) < 60)
			return rtf.format(Math.round(minutes), 'minute');
		const hours = minutes / 60;
		if (Math.abs(hours) < 24) return rtf.format(Math.round(hours), 'hour');
		const days = hours / 24;
		return rtf.format(Math.round(days), 'day');
	}
}
